__webpack_require__.p = "https://act-dashboard.studyportals.eu/dist/";